<section class="left-nav-wrapper scroll-container" *ngIf="render">
  <div class="d-flex">
    <div class="me-3">
      <h1 class="page-title mb-0">Payroll Worksheet</h1>
    </div>
    <div class="flex-fill d-inline-flex justify-content-end">
      <div class="title-bar-btn">
        <button
          cpGTagEvent
          [params]="{ event_label: 'payroll_auto_payroll_grid_skip' }"
          class="btn btn-secondary"
          (click)="skipAutomaticPay()">
          Skip Automatic this period
        </button>
      </div>
      <div class="title-bar-btn">
        <button
          cpGTagEvent
          [params]="{ event_label: 'payroll_auto_payroll_grid_regenerate' }"
          class="btn btn-primary"
          (click)="regenerateWorksheet()">
          Regenerate Worksheet
        </button>
      </div>
    </div>
  </div>
  <div class="d-flex flex-fill">
    <div *ngIf="payroll">
      <small>
        <span class="me-3">
          Last Day of Pay Cycle:&nbsp;<strong>{{ payrollMgmt.periodEndDisplay(payroll) }}</strong>
        </span>
        <span class="me-3">
          Pay Date:&nbsp;<strong>{{
            payroll.PayDate.toString() | slice: 0 : 10 | date: 'MM/dd/yyyy'
          }}</strong>
        </span>
      </small>
    </div>
    <div id="lastSavedBy" class="flex-fill d-inline-flex justify-content-end">
      <div *ngIf="isLoading" class="text-center pe-4 pt-1">
        <i class="fas fa-2x fa-circle-notch fa-spin"></i>
        <div>Saving...</div>
      </div>
      <div *ngIf="!isLoading && payroll" class="text-center">
        <i class="fas fa-2x fa-save"></i>
        <small>
          <div>Last Saved by {{ payroll.LastEditBy }}</div>
          <strong>{{
            payroll.LastEditOn.toString() | slice: 0 : 10 | date: 'MM/dd/yyyy h:mma'
          }}</strong>
        </small>
      </div>
    </div>
  </div>
  <ag-grid-angular
    [ngStyle]="{ height: gridHeight }"
    style="max-height: 700px"
    class="ag-theme-alpine"
    [rowData]="rowData"
    (cellKeyDown)="onCellKeyDown($event)"
    [columnDefs]="columnDefs"
    [columnTypes]="columnTypes"
    [singleClickEdit]="true"
    [stopEditingWhenCellsLoseFocus]="true"
    [gridOptions]="gridOptions">
  </ag-grid-angular>
</section>
